import { expirationTitleAse } from './expiration-title/ase';
import { expirationTitleBzs } from './expiration-title/bzs';

export const expirationPageTitleAnimationCodes = {
  pt: expirationTitleBzs,
  en: expirationTitleAse,
};
